import React from "react";
import "./Permission.css"

const StepIndicator = ({ stepNumber ,customClass}) => {
  return (
    <div
    className={customClass ? customClass : "step-indicator"}

    >
      {/* Left Line */}
      <div
        style={{
          flex: 1,
          height: "1px",
          backgroundColor: "grey",
        }}
      />

      {/* Circle with Number */}
      <div
        style={{
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          backgroundColor: "#FF0083",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
        //   fontWeight: "bold",
          fontSize: "0.8rem",
          margin: "0 10px",
        }}
      >
        {stepNumber}
      </div>

      {/* Right Line */}
      <div
        style={{
          flex: 1,
          height: "1px",
          backgroundColor: "grey",
        }}
      />
    </div>
  );
};

export default StepIndicator;
